// GERADO de backend-senne/src/contracts — NÃO editar; rode scripts/sync-contracts.sh

import { z } from 'zod'

// PASSWORD e NOT_FOUND nunca são retornados por get-by-identifier.usecase.ts (nenhum dos
// nove pontos de retorno os emite) e LOGIN é retornado e não estava declarado — medido em
// 2026-09-21 (spec 021, D2/D3). O enum abaixo é exatamente o de
// GetByIdIdentifierOutputDTO.next_step, que por sua vez importa este tipo (T-04), então as
// duas fontes não podem mais divergir sem um erro de tipo.
/** Próximo passo após resolver o identificador. */
export const loginNextStepSchema = z.enum([
    'LOGIN',
    'REGISTER', // CPF de paciente não achado → cadastro (spec 20261021-141500: sem protocolo + senha)
    'SELECT_BIRTHDATE', // múltiplos pacientes no mesmo CPF
    'VALIDATE_PHONE',
    'VALIDATE_MAIL',
    'VALIDATE_EMAIL', // pré-paciente encontrado → validação de e-mail
])
export type LoginNextStep = z.infer<typeof loginNextStepSchema>

export const validateIdentifierRequestSchema = z.object({
    identifier: z.string().min(1), // e-mail OU CPF
    // Ambos opcionais e o schema NÃO é `.strict()` de propósito (spec 021, F6): o
    // portal manda `roleId` number + `birthDate` string, mas `getByCpf` manda só
    // `identifier` — tornar obrigatório ou strict quebraria essa segunda chamada real.
    roleId: z.number().optional(),
    birthDate: z.string().optional(),
})
export type ValidateIdentifierRequest = z.infer<
    typeof validateIdentifierRequestSchema
>

// Chave é `next_step` (snake_case), não `nextStep`: é o que todo ponto de retorno do use
// case emite e o que o portal já consome (types.ts:179) — medido em 2026-09-21 (spec 021,
// D1). `.strict()` é deliberado: um `z.object()` comum descarta chave desconhecida em
// silêncio, então sem `.strict()` um campo vazado passaria despercebido em vez de ser
// rejeitado (spec 021, AC-3). Não afrouxar com `.passthrough()` ou `z.any()`.
// Sem `email`, `cellphone` e `userId` (P20EE-94): a rota é anônima, e por CPF ela devolvia o e-mail da conta. O
// `strict()` é o que reprova um ponto de retorno que voltar a mandá-los.
export const validateIdentifierResponseSchema = z
    .object({
        next_step: loginNextStepSchema,
        users: z
            .array(
                z
                    .object({
                        id: z.number(),
                        birthday: z.string(),
                        status: z.number(),
                    })
                    .strict()
            )
            .nullable()
            .optional(),
        mfaToken: z.string().optional(),
        expiresAt: z.string().optional(),
    })
    .strict()
export type ValidateIdentifierResponse = z.infer<
    typeof validateIdentifierResponseSchema
>
